import { CampaignEditingData } from "@api/common";
import { defineAction } from "rd-action-creators";
import { Country } from "../api";

export const createOrUpdateCampaignAction = defineAction<{
    clientId: string;
    campaignId: string;
    mode: "create" | "update" | "purchase save" | "purchase new campaign";
}>("CREATE OR UPDATE CAMPAIGN");

export const getCampaignByIdAction = defineAction<{
    clientId: string;
    campaignId: string;
    mode: "summary" | "edit" | "update";
}>("GET CAMPAIGN BY ID");

export const purchaseCampaignByIdAction = defineAction<{ clientId: string; campaignId: string }>(
    "PURCHASE CAMPAIGN BY ID"
);

export const changeSaveOrPurchaseProcessingAction = defineAction<{ isProcessing: boolean }>(
    "CHANGE SAVE OR PURCHASE PROCESSING STATE"
);

export const refreshEdititngCampaignState = defineAction<{}>("REFRESH EDITING CAMPAIGN STATE");

export const uploadCountryListAction = defineAction<{ countryList: Country[] }>("LOAD COUNTRY LIST");

export const searchLocationByQueryAction = defineAction<{
    query: { [k: string]: string };
    region: string;
}>("SEARCH LOCATION BY QUERY");

export const restoreCampaignEditingDataAction = defineAction<{
    data: CampaignEditingData;
}>("RESTORE CAMPAIGN EDITING DATA");

export const deleteCampaignEditingDataAction = defineAction("DELETE CAMPAIGN EDITING DATA");

export const changeCampaignChangesFlagAction = defineAction<{ status: boolean }>("CHANGE CAMPAIGN CHANGES FLAG");

export const changeUpdateNavStateFlagAction = defineAction<{ status: boolean }>("CHANGE UPDATE NAV STATE FLAG");

export const setAdUnitTypeAction = defineAction<{ adUnitType: string }>("SET AD UNIT TYPE");

export const setPriceModelAction = defineAction<{ priceModel: string }>("SET PRICE MODEL");

export const setPrimaryKPIAction = defineAction<{ primaryKPI: string }>("SET PRIMARY KPI MODEL");

export const changeUpdateCheckTimetableFlagAction = defineAction<{ status: boolean }>(
    "CHANGE UPDATE CHECK TIMETABLE FLAG"
);
export const openTimetableWarningAction = defineAction("OPEN TIMETABLE WARNING");

export const setAdUnitFormatAction = defineAction<{ adUnitFormat: string }>("SET AD UNIT FORMAT");

export const changeRequiredDataLoadingStatusAction = defineAction<{ status: boolean }>(
    "CHANGE REQUIRED DATA LOADING STATUS"
);
